import { ArticlePieceDto } from "./ArticlePieceDto";

export class ArticleViewDto {
    public id!: string;
    public title!: string;
    public description!: string;
    public pieces!: ArticlePieceDto[];
}
